<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()" [strong]="true" data-cy="bet-amount-x">X</ion-button>
    </ion-buttons>
    <ion-title class="tw-text-center" data-cy="bet-amount-title">BET AMOUNT</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="bet-amount-modal-container" data-cy="bet-amount-modal">
  <input
    inputmode="numeric"
    type="text"
    class="tw-text-center tw-text-[23px] tw-text-bold tw-mt-[30px]"
    placeholder="00.00"
    step="0.01" min="0" pattern="^\d+(\.\d{1,2})?$"
    [(ngModel)]="amount"
    (keyup)="inputAmount($event, amount)"
    amwager3DecimalInput
    data-cy="bet-amount-input"
  />

  <p
    *ngFor="let amount of showBetAmounts"
    (click)="chooseAmount(amount)"
    class="tw-text-center tw-text-[23px] tw-text-bold"
  >
    <span *ngIf="!((amount < minBet) || (amount > maxBet))"
      [attr.data-cy]="
        amount >= minBet &&
        amount <= maxBet ? 'bet-amount-' + amount : null"
    >
      {{ amount | formatAmount }}
    </span>
  </p>

  <!-- <p (click)="chooseAmount(1.00)" class="tw-text-center tw-text-[23px] tw-text-bold" data-cy="bet-amount-1">$1.00</p>
  <p (click)="chooseAmount(2.00)" class="tw-text-center tw-text-[23px] tw-text-bold">$2.00</p>
  <p (click)="chooseAmount(3.00)" class="tw-text-center tw-text-[23px] tw-text-bold">$3.00</p>
  <p (click)="chooseAmount(4.00)" class="tw-text-center tw-text-[23px] tw-text-bold">$4.00</p>
  <p (click)="chooseAmount(5.00)" class="tw-text-center tw-text-[23px] tw-text-bold" data-cy="bet-amount-5">$5.00</p>
  <p (click)="chooseAmount(10.00)" class="tw-text-center tw-text-[23px] tw-text-bold" data-cy="bet-amount-10">$10.00</p>
  <p (click)="chooseAmount(20.00)" class="tw-text-center tw-text-[23px] tw-text-bold" data-cy="bet-amount-20">$20.00</p>
  <p (click)="chooseAmount(50.00)" class="tw-text-center tw-text-[23px] tw-text-bold" data-cy="bet-amount-50">$50.00</p>
  <p (click)="chooseAmount(100.00)" class="tw-text-center tw-text-[23px] tw-text-bold" data-cy="bet-amount-100">$100.00</p>
  <p (click)="chooseAmount(200.00)" class="tw-text-center tw-text-[23px] tw-text-bold">$200.00</p>
  <p (click)="chooseAmount(500.00)" class="tw-text-center tw-text-[23px] tw-text-bold">$500.00</p> -->

  <!-- TRI, SPR, PKS -->
  <!-- <p (click)="chooseAmount(0.5)" class="tw-text-center tw-text-[23px] tw-text-bold">
    $0.5
  </p> -->

  <p class="tw-text-center tw-mt-[10px]">
    <ion-button *ngIf="showConfirmBtn" (click)="betAmount()" class="confirm-btn" data-cy="bet-amount-confirm">
      Confirm
    </ion-button>
  </p>
</ion-content>
